import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "confirmation", "actions"]

  confirmDelete() {
    this.#toggleConfirmation(true)
  }

  cancelDelete() {
    this.#toggleConfirmation(false)
  }

  #toggleConfirmation(visible) {
    this.previewTarget.classList.toggle("tw-hidden", visible)
    this.actionsTarget.classList.toggle("tw-hidden", visible)
    this.confirmationTarget.classList.toggle("tw-hidden", !visible)
    this.confirmationTarget.classList.toggle("tw-flex", visible)
  }
}